import { FunctionComponent, useMemo, type CSSProperties } from "react"

type LogoFullType = {
  dimensions?: string

  /** Style props */
  logoWrapWidth?: CSSProperties["width"]
  logoWrapHeight?: CSSProperties["height"]
  image1Width?: CSSProperties["width"]
  image1Height?: CSSProperties["height"]
}

const LogoFull: FunctionComponent<LogoFullType> = ({
  dimensions = "/v3/assets/meseekna-logo@2x.png",
  logoWrapWidth = "189px",
  logoWrapHeight = "31.5px",
  image1Width = "188.61px",
  image1Height = "30.02px",
}) => {
  const logoWrapStyle: CSSProperties = useMemo(() => {
    return {
      width: logoWrapWidth,
      height: logoWrapHeight,
    }
  }, [logoWrapWidth, logoWrapHeight])

  const image1Style: CSSProperties = useMemo(() => {
    return {
      width: image1Width,
      height: image1Height,
    }
  }, [image1Width, image1Height])

  return (
    <div className="relative flex flex-row items-start justify-start">
      <div className="relative w-[126px] h-[21px]" style={logoWrapStyle}>
        <div
          className="absolute top-[0px] left-[0px] w-[125.74px] h-[20.01px]"
          style={image1Style}>
          <img
            className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] max-w-full overflow-hidden max-h-full object-cover"
            alt=""
            src={dimensions}
          />
        </div>
      </div>
    </div>
  )
}

export default LogoFull
